/**
 * <OpenedFileBadge> — render for `lx_open_file` tool calls. The actual
 * file-open side effect is handled by the existing `usePlatformOpListener`
 * → WorkspaceFilePane flow (a separate concern); this component is the
 * IN-CHAT visual confirmation that the agent requested it.
 */
import { FileSymlink } from "lucide-react";
import type { ToolUseBlock as ToolUseBlockType } from "@/types/content-blocks";

interface OpenedFileBadgeProps {
  block: ToolUseBlockType;
}

function readPath(input: unknown): string | null {
  if (!input || typeof input !== "object") return null;
  const r = input as Record<string, unknown>;
  return typeof r.path === "string" && r.path ? r.path : null;
}

export function OpenedFileBadge({ block }: OpenedFileBadgeProps) {
  const path = readPath(block.input);
  return (
    <div
      data-testid="opened-file-badge"
      className="my-1 inline-flex items-center gap-1.5 rounded border border-cream-300 bg-cream-100/30 px-2 py-1 text-caption text-coffee-700 dark:border-coffee-700 dark:bg-coffee-900/30 dark:text-cream-300"
    >
      <FileSymlink size={12} />
      <span>Opened</span>
      {path && <span className="font-mono">{path}</span>}
    </div>
  );
}
